import { render, staticRenderFns } from "./CreateTopic.vue?vue&type=template&id=6a51a9c8&scoped=true&"
import script from "./CreateTopic.vue?vue&type=script&lang=js&"
export * from "./CreateTopic.vue?vue&type=script&lang=js&"
import style0 from "./CreateTopic.vue?vue&type=style&index=0&id=6a51a9c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a51a9c8",
  null
  
)

export default component.exports